import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

export const logout = createAction('auth/logout');

export const logoutAction = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  thunkAPI.dispatch(logout());
});
